import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { Role } from '../../types';

interface Props {
  allowedRoles: Role[];
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<Props> = ({ allowedRoles, children }) => {
  const { user, token } = useAppSelector((state) => state.auth);

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
